export default {
  name: "DsfSlotRenderProxy",
  props: {
    tag: {
      type: String,
      default: ""
    },
    owner: {
      type: Object,
      default() {
        return null;
      }
    },
    slotKey: {
      type: String,
      default: ""
    },
    slotData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  update(){
  },
  render(h) {
    let owner = this.owner;
    if (!owner) {
      return h();
    }
    let slotKey = this.slotKey;
    let slotData = this.slotData;
    let vnodes = owner?.$scopedSlots?.[slotKey]?.(slotData) || null;
    if (vnodes && vnodes.length == 1 && !this.tag) {
      return vnodes;
    }
    let tag = this.tag || "div";
    return h(tag, { staticClass: "ds-slot-proxy" }, vnodes);
  }
};
